import { render, staticRenderFns } from "./OrganismDashboard.vue?vue&type=template&id=7b614c8f&scoped=true&"
import script from "./OrganismDashboard.vue?vue&type=script&lang=js&"
export * from "./OrganismDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OrganismDashboard.vue?vue&type=style&index=0&id=7b614c8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b614c8f",
  null
  
)

export default component.exports